const PATH = "";

const ENDPOINTS = {
  TRACKING_CONTEXT: "/context.json",
  TRACKING_EVENTS: "/eventcollector",
};

export type TrackingEndpoints = keyof typeof ENDPOINTS;
export const TrackingCollection = { PATH, ENDPOINTS };
